import { render, staticRenderFns } from "./AccessoryMenu.vue?vue&type=template&id=40a215b0&scoped=true&"
import script from "./AccessoryMenu.vue?vue&type=script&lang=ts&"
export * from "./AccessoryMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AccessoryMenu.vue?vue&type=style&index=0&id=40a215b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a215b0",
  null
  
)

export default component.exports